import { SwitchKBComponent } from 'src/pages/ControlDeskPage/DataSourceSection/KnowledgeBases/AssignKnowledgeBasePopup/SwitchKBComponent';
import React from 'react';
import {
  useAssignProjectKnowledgeBaseMutation,
  useGetProjectByIdQuery,
  useUnassignProjectKnowledgeBaseMutation,
} from 'src/services';
import { useParams } from 'react-router-dom';
import { ProductsTypeBack } from 'src/constants/products';

export const AssignKnowledgeBaseListItem = ({ knowledgeBase }) => {
  const { id } = useParams();
  const { data: currentProject } = useGetProjectByIdQuery({ id: id }) as any;
  const defaultChecked = knowledgeBase.projects.some((project) => `${project.id}` === id);

  const [assignKB, { isLoading: assignKBisLoading }] = useAssignProjectKnowledgeBaseMutation();
  const [unassignKB, { isLoading: unassignKBIsLoading }] =
    useUnassignProjectKnowledgeBaseMutation();

  const onCheckedChange = (checked) => {
    const request = {
      project_type: ProductsTypeBack[currentProject?.project_type],
      projectId: currentProject.id,
      body: [knowledgeBase.id],
    };

    checked ? assignKB(request) : unassignKB(request);
  };

  return (
    <li className={'flex flex-row justify-between w-full pb-2.5 border-b border-light'}>
      <div>
        <p className={'text-ebony_opacity_80 font-medium text-sm'}>{knowledgeBase.name}</p>
      </div>
      <div>
        <SwitchKBComponent
          defaultChecked={defaultChecked}
          onCheckedChange={onCheckedChange}
          isFetching={assignKBisLoading || unassignKBIsLoading}
        />
      </div>
    </li>
  );
};
